import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../src/assets/img/rank/first.png';
import _imports_1 from '../../../src/assets/img/rank/second.png';
import _imports_2 from '../../../src/assets/img/rank/three.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d026b368"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "detail"
};
var _hoisted_2 = {
  class: "content"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, [/*#__PURE__*/_createElementVNode("span", null, "积分排名")]), /*#__PURE__*/_createElementVNode("div", {
    class: "rule"
  }, [/*#__PURE__*/_createElementVNode("p", null, "*只显示积分前10名的人员*")])], -1);
});

var _hoisted_4 = {
  class: "bottom",
  style: {
    "margin-top": "15px"
  }
};
var _hoisted_5 = {
  key: 0,
  src: _imports_0,
  style: {
    "width": "25px",
    "height": "30px",
    "vertical-align": "middle"
  }
};
var _hoisted_6 = {
  key: 1,
  src: _imports_1,
  style: {
    "width": "25px",
    "height": "30px",
    "vertical-align": "middle"
  }
};
var _hoisted_7 = {
  key: 2,
  src: _imports_2,
  style: {
    "width": "25px",
    "height": "30px",
    "vertical-align": "middle"
  }
};
var _hoisted_8 = {
  key: 3,
  class: "item-rank"
};
var _hoisted_9 = {
  class: "item-name"
};
var _hoisted_10 = {
  class: "item-score"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "积分排行",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.rank, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "rankbox"
    }, [index == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : index == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : index == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(index + 1), 1)), _createElementVNode("span", _hoisted_9, _toDisplayString(item.username), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(item.score) + "分", 1)]);
  }), 128))])])])], 64);
}